import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Button, Card, Checkbox, Form, Input, Modal } from 'antd';
import { ExclamationCircleOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import authService from "../services/auth.service";

function Login() {

    const [username, setUsername] = useState([]);
    const [password, setPassword] = useState([]);
    const [loading, setLoading] = useState(false);
    const { isLoggedIn } = useSelector(state => state.auth);
    const { message } = useSelector(state => state.message);
    const [isVisible, setVisible] = useState(false);
    const dispatch = useDispatch();
    const { error } = Modal;

    const [form] = Form.useForm();

    const showModal = () => {
        setVisible(true);
    };

    const showError = (message) => {
        error({
            title: 'Hata',
            icon: <ExclamationCircleOutlined />,
            content: message || "Kullanıcı adı veya parola hatalıdır",
            okText: 'Tamam',
            onOk() {
                // afterClose: window.open('/authservice-ui/index.html', "_self")
                setLoading(false)
                form.setFieldsValue({
                    password: null,
                })
            },
        });
    };

    const handleLogin = (values) => {
        setLoading(true)
        const {
            code,
            isApiUser,
            username,
            password,
        } = values;
        authService.login(code, isApiUser, username, password)
            .then(res => {
                // console.log(res.token);
                if (res && res.validated && res.validated === true) {
                    if (res.token) {
                        // console.log("Validated: " + res.validated);
                        // console.log("Token: " + res.token);
                        localStorage.setItem("token", "Bearer " + res.token);
                        window.open('/CreditSystem/index.html', "_self");
                    } else {
                        sessionStorage.setItem("token", res.token);
                        sessionStorage.setItem("username", username);
                        sessionStorage.setItem("password", password)
                        window.open('/authservice-ui/sms/index.html', "_self");
                        // console.log(username);
                        // console.log(password);
                        // console.log(res.token);
                    }
                } else {
                    showError();
                }
            }).catch(error => {
                localStorage.removeItem("token");
                const errorMessage = error.response?.data?.message || "Kullanıcı adı veya parola hatalıdır";
                showError(errorMessage);
            });

    };

    if (isLoggedIn) {
        console.log(localStorage.token)
        //window.open('/CreditSystem/index.html', "_self");
    }

    const sendToken = (values) => {
        const {
            token,
        } = values;
        setLoading(true);
        dispatch((token))
            .then(() => {
                this.props.history.push("/");
            })
            .catch(() => {
                showError();
                /* setLoading(false);*/
            });

    };

    const openDealerPage = () => {
        window.open('/authservice-ui/register/index.html', "_self");
    };


    return (
        <div className="form_design">
            <Card title="Üye Girişi">
                <Form form={form} onFinish={handleLogin} name="normal_login" className="login-form"
                    initialValues={{ remember: true }}>
                    <Form.Item name="username"
                        className="input_border"
                        rules={[{ required: true, message: 'E-Posta bilgisi boş olamaz' }]}>

                        <Input
                            value={username}
                            suffix={<UserOutlined className="site-form-item-icon" />}
                            placeholder="E-Posta"
                            autoComplete="username"
                        />
                    </Form.Item>
                    <Form.Item name="password"
                        className="input_border"
                        rules={[{ required: true, message: 'Parola bilgisi boş olamaz' }]}>
                        <Input.Password
                            onChange={(() =>
                                setPassword(password)
                            )}
                            value={password}
                            placeholder="Parola"
                            autoComplete="current-password" />
                    </Form.Item>
                    <Form.Item>
                        {/*<Form.Item name="remember"*/}
                        {/*           valuePropName="non-checked"*/}
                        {/*           style={{display: 'inline-block', width: 'calc(50% - 10px)'}}*/}
                        {/*           noStyle>*/}
                        {/*    <Checkbox>Beni Hatırla</Checkbox>*/}
                        {/*</Form.Item>*/}
                        <Form.Item
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)', margin: '0 10px' }}
                        >
                            <Link className="text-link"
                                to="/authservice-ui/forgot/index.html">Parolanı
                                mı unuttun?</Link>
                        </Form.Item>
                    </Form.Item>
                    {/*<Form.Item>
                        <div className="extra mt-3 row justify-content-between">
                            <div className="col-6">
                                <div className="form-check">
                                    <Form.Item name="remember" valuePropName="non-checked" noStyle>
                                        <Checkbox>Beni Hatırla</Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="auth-option text-center pt-2"><Link className="text-link"
                                                                                    to="/authservice-ui/forgot">Parolanı
                                    mı unuttun?</Link></div>
                            </div>
                        </div>
                    </Form.Item>*/}
                    <Form.Item>
                        <Button size="large" type="primary" disabled={loading} htmlType="submit" block>Giriş Yap</Button>
                    </Form.Item>
                    <Form.Item>
                        <Button size="large" type="primary" htmlType="submit" onClick={openDealerPage} block>Bayi Hesabı Aç</Button>
                    </Form.Item>
                    {/*<div className="auth-option text-center pt-2"><Link className="text-link" to="/authservice-ui/register/index.html">Bayi Hesabı Aç</Link></div>*/}
                </Form>
            </Card>
        </div>
    );
};

export default Login;
